export default {
  timeout: 600000, // 10分钟（毫秒）
  lastActiveTime: Date.now(),
  timer: null,

  startTimer() {
    this.clearTimer();
    this.timer = setTimeout(() => {
      this.logout();
    }, this.timeout);
  },

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },

  resetTimer() {
    const now = Date.now();
    if (now - this.lastActiveTime > this.timeout) {
      this.logout();
    } else {
      this.lastActiveTime = now;
      this.startTimer();
    }
  },

  handleVisibilityChange() {
    const now = Date.now();
    if (now - this.lastActiveTime > this.timeout) {
      this.logout();
    } else {
      this.lastActiveTime = now;
      this.startTimer();
    }
  },

  logout() {
    sessionStorage.removeItem('token');
    window.location.href = '/login';
  },

  bindEventListeners() {
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];
    events.forEach(event => {
      document.addEventListener(event, this.resetTimer.bind(this));
    });
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  },

  unbindEventListeners() {
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];
    events.forEach(event => {
      document.removeEventListener(event, this.resetTimer.bind(this));
    });
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  },

  init() {
    this.bindEventListeners();
    this.startTimer();
  },

  destroy() {
    this.unbindEventListeners();
    this.clearTimer();
  }
};